var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"newsletter-section content-padd",class:{ isMobile: _vm.isMobile }},[_c('div',{staticClass:"news-content content-width"},[_vm._m(0),_c('div',{ref:"edbNewsletter",staticClass:"news-form-script"})])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"news-title"},[_c('h2',{staticClass:"title-simple"},[_vm._v(" Bądź na bieżąco "),_c('br'),_vm._v(" z aktualnościami GUNB ")])])
}]

export { render, staticRenderFns }